import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService } from './base.service';

export class GenericService<T> extends BaseService
{

  constructor(
    http: HttpClient, genericRoute: string, version: string)
  {
    super(http, genericRoute, version)


  }

}
